// const environments = {
//   // local: {
//   //   url: "https://sdeiaiml.com:8003/",
//   // },

//   staging: {
//     url: "https://sdeiaiml.com:8004/",
//   },
  
//   // production: {
//   //   url: "https://medxgo.com:8084",
//   // },
// };
// export default environments;
const environments = {
  local: {
    url: "http://0.0.0.0:8003/",
    // url: "https://sdeiaiml.com:9034/",
  },

  staging: {
    url: "https://sdeiaiml.com:9034/",
  },
  
  production: {
  
    url: "https://itafclinicalapp.com/api/",
  },
};
export default environments;
